import request from '../request'

/**
 * 查询设计计划人员配置（精简版）
 * @param {Object} params - 查询参数
 */
export function getDesignPlanPersonnel(params) {
    return request({
        url: '/project-service/cosys/design/plan/personnel',
        method: 'GET',
        params
    })
}

/**
 * 查询简易项目申请表的设计计划人员配置（精简版）
 * @param {Object} params - 查询参数
 */
export function fetchSimplePlanPersonnel(params) {
    return request({
        url: '/project-service/cosys/design/plan/simple/personnel',
        method: 'GET',
        params
    })
}

